export default {
  setSearch(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.search = {
        ...state.search,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.search = {
        ...state.search,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.search = {
        ...state.search,
        jyutai: payload,
      };
    }
  },
  setRegistrationId(state, payload) {
    state.registrationId = payload;
  },
  setRegistraionData(state, payload) {
    if (payload != undefined) {
      const totalPoint = payload.TotalPoint;
      if (totalPoint) {
        const rank = Math.trunc(totalPoint / 100) + 1;
        payload.Rank = rank;
        console.log("setRegistraionData totalPoint: " + totalPoint + " => " + rank);
      }
    }
    state.registrationData = payload;
  },
  setAnswers(state, payload) {
    state.answers = payload;
  },
  setCurrentPageName(state, payload) {
    state.currentPageName = payload;
  },
  setIsLoggedInWithFirebaseAuth(state, payload) {
    state.isLoggedInWithFirebaseAuth = payload;
  },
  setModal(state, payload) {
    state.modal = payload;
  },
  setSearchState(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.searchState = {
        ...state.searchState,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.searchState = {
        ...state.searchState,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.searchState = {
        ...state.searchState,
        jyutai: payload,
      };
    }
  },
  setSearchRoute(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.searchState = {
        ...state.searchState,
        dropspot: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.searchState = {
        ...state.searchState,
        jyutai: payload,
      };
    }
  },
  setSelectedTab(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.tabs = {
        ...state.tabs,
        dropspot: payload,
      };
    }
  },
  setSelectedFilter(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.selectedFilter = {
        ...state.selectedFilter,
        dropspot: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.selectedFilter = {
        ...state.selectedFilter,
        jyutai: payload,
      };
    }
  },
  setSelectedSpotData(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.selectedSpotData = {
        ...state.selectedSpotData,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.selectedSpotData = {
        ...state.selectedSpotData,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.selectedSpotData = {
        ...state.selectedSpotData,
        jyutai: payload,
      };
    }
  },
  setSelectedSpotCommentData(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.selectedSpotCommentData = {
        ...state.selectedSpotCommentData,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.selectedSpotCommentData = {
        ...state.selectedSpotCommentData,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.selectedSpotCommentData = {
        ...state.selectedSpotCommentData,
        jyutai: payload,
      };
    }
  },
  setSelectedSpotTicketData(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.selectedSpotTicketData = {
        ...state.selectedSpotTicketData,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.selectedSpotTicketData = {
        ...state.selectedSpotTicketData,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.selectedSpotTicketData = {
        ...state.selectedSpotTicketData,
        jyutai: payload,
      };
    }
  },
  setMissions(state, payload) {
    state.missions = payload;
  },
  setCheckinList(state, payload) {
    state.checkinList = payload;
  },
  setImageReputationList(state, payload) {
    state.imageReputationList = payload;
  },
  loadingStart(state) {
    state.loading = true;
  },
  loadingEnd(state) {
    state.loading = false;
  },
  setCurrentLatLng(state, payload) {
    state.currentLat = payload.lat;
    state.currentLng = payload.lng;
  },
  setDepLatLng(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.DepLatLng = {
        ...state.DepLatLng,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.DepLatLng = {
        ...state.DepLatLng,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.DepLatLng = {
        ...state.DepLatLng,
        jyutai: payload,
      };
    }
  },
  setDesLatLng(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.DesLatLng = {
        ...state.DesLatLng,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.DesLatLng = {
        ...state.DesLatLng,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.DesLatLng = {
        ...state.DesLatLng,
        jyutai: payload,
      };
    }
  },
  resetDepLatLng(state) {
    state.DepLatLng = undefined;
  },
  resetDesLatLng(state) {
    state.DesLatLng = undefined;
  },
  setOriginalApiData(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.originalApiData = {
        ...state.originalApiData,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.originalApiData = {
        ...state.originalApiData,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.originalApiData = {
        ...state.originalApiData,
        jyutai: payload,
      };
    }
  },
  setMap(state, payload) {
    state.currentMap = payload;
  },
  setSelectedSpotType(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.selectedSpotType = {
        ...state.selectedSpotType,
        dropspot: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.selectedSpotType = {
        ...state.selectedSpotType,
        jyutai: payload,
      };
    }
  },
  setDropDestionaton(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.dropDestionaton = {
        ...state.dropDestionaton,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.dropDestionaton = {
        ...state.dropDestionaton,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.dropDestionaton = {
        ...state.dropDestionaton,
        jyutai: payload,
      };
    }
  },
  setLastRoute(state, payload) {
    if (state.currentPageName === "RouteSearch") {
      state.lastRoute = {
        ...state.lastRoute,
        dropspot: payload,
      };
    } else if (state.currentPageName === "MyPage") {
      state.lastRoute = {
        ...state.lastRoute,
        mypage: payload,
      };
    } else if (state.currentPageName === "JyutaiSearch") {
      state.lastRoute = {
        ...state.lastRoute,
        jyutai: payload,
      };
    }
  },
  loadingStartMini(state) {
    state.miniLoading = true;
  },
  loadingEndMini(state) {
    state.miniLoading = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutation.js